// action types
export const SET_TICKETS = 'SET_TICKETS';
export const FETCH_ITEMS = 'FETCH_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const ADD_ANSWER_ITEM = 'ADD_ANSWER_ITEM';
export const ADD_DOCUMENT_FLAG = 'ADD_DOCUMENT_FLAG';
export const DELETE_ITEM = 'DELETE_ITEM';
export const SAVE_ITEM = 'SAVE_ITEM';
export const FETCH_ITEM_SUCCESS = 'FETCH_ITEM_SUCCESS';
export const FETCH_ITEM_FAILURE = 'FETCH_ITEM_FAILURE';